<template>
  <div class="hotelux-current-user">
    <div v-if="!user" class="auth-buttons">
      <!-- 视觉上由 text-transform 转为大写，这里让可访问名称与视觉保持一致 -->
      <button
        type="button"
        class="register-btn"
        :aria-label="$t('shared.auth.register').toUpperCase()"
        @click="handleRegister"
      >
        <UIText>{{ $t("shared.auth.register") }}</UIText>
      </button>
      <y-button
        class="signin-btn"
        :class="{ 'is-sticky': isSticky }"
        :aria-label="$t('shared.auth.signIn').toUpperCase()"
        @click="handleSignIn"
      >
        <UIText>{{ $t("shared.auth.signIn") }}</UIText>
      </y-button>
    </div>

    <div v-else class="user-info" @click="emit('member')">
      <UIText class="user-name" type="bold">{{ user.name }}</UIText>
      <div class="user-avatar">
        <img class="avatar-img" :src="AvatarRef" alt="avatar" />
        <img
          v-if="memberLevel"
          class="member-level"
          :src="memberLevel"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { useLoginRedirect } from "@/hooks/useLoginRedirect";
import { useUserStoreHook } from "@/store/modules/user";

import UIText from "../UiText/index.vue";
import defaultAvatar from "./icon-head.png";

defineProps({
  settings: {
    type: Array,
    default: () => []
  },
  isSticky: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["member"]);

const router = useRouter();
const route = useRoute();
const userStore = useUserStoreHook();
const yChannelStore = useYChannelStoreHook();
const { redirectToLogin } = useLoginRedirect();
const { user } = storeToRefs(userStore);

const memberLevel = computed(() => {
  return yChannelStore.configs?.level[
    user.value?.loyaltyProgram?.ref?.type || "guest"
  ];
});

const handleSignIn = () => {
  redirectToLogin(route.fullPath);
};

const AvatarRef = computed(() => {
  return user.value?.photoUrls[0] ? user.value.photoUrls[0] : defaultAvatar;
});

const handleRegister = () => {
  const redirectUrl = route.fullPath;
  if (yChannelStore.configs?.registerToSelectPage) {
    router.push({
      path: "/channel-select",
      query: {
        tab: "register",
        redirect: redirectUrl
      }
    });
  } else {
    router.push({
      path: "/login",
      query: {
        tab: "register",
        redirect: redirectUrl,
        ...route.query
      }
    });
  }
};

defineOptions({
  name: "HoteluxCurrentUser"
});
</script>

<style lang="scss" scoped>
.hotelux-current-user {
  display: flex;
  align-items: center;
  color: inherit;
}

.auth-buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}

.signin-btn {
  min-width: 97px;
  height: 40px;
  padding: 0 24px;
  // font-family: Lato, -apple-system, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  letter-spacing: 1px;
  border-radius: 0;
  transition: all 0.3s ease;

  background: rgba(0, 0, 0, 0.5);

  backdrop-filter: blur(2.5px);
  -webkit-backdrop-filter: blur(2.5px);

  border: 1px solid rgba(255, 255, 255, 0.2);

  &:hover {
    background: rgba(0, 0, 0, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    color: #fff;
  }

  // box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.register-btn {
  padding: 0;
  // 跟随页头文字颜色：Hero 上为白色，吸顶浅色状态下为 #212223
  color: inherit;
  cursor: pointer;
  background: transparent;
  border: 0;
  text-transform: uppercase;
  // font-family: lato;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;

  &:hover {
    text-decoration: underline;
    text-underline-offset: 6px;
  }
}

.signin-btn {
  color: inherit;
  text-transform: uppercase;

  // 吸顶后页头底色变浅，边框跟随文字颜色
  &.is-sticky {
    border-color: #212223;
    background-color: transparent;
    &:hover {
      background: #fff;
    }
  }
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
  }
}

.user-name {
  // font-family: "lato-bold";
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: inherit;
}

.user-avatar {
  position: relative;

  .avatar-img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50%;
  }

  .member-level {
    position: absolute;
    // top: 22px;
    bottom: -2px;
    left: 50%;
    width: auto;
    height: 14px;
    transform: translateX(-50%);
    border-radius: 0;
  }
}
</style>
